<style lang="less" scoped>
/deep/ .el-tabs__item.is-top {width: 150px;text-align: center;padding-left: 20px;}
</style>

<template>
  <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane label="矿业论坛会议列表" name="1">
      <KyltMAdd :updataID='updataID'></KyltMAdd>
    </el-tab-pane>
    <el-tab-pane label="分类管理列表" name="2"></el-tab-pane>
  </el-tabs>
</template>

<script>
/**
 * lx
 * 矿业论坛会议修改
 */
import KyltMAdd from '../../../../static/form/KyltMAdd.vue'
export default {
  components: {
    KyltMAdd
  },
  data()
  {
    return {
      activeName: '1',
      updataID: this.$route.query.id
    }
  },
  methods: {
    handleClick(tab, event)
    {
      this.$router.push({path: '/KyltMgl'})
      this.$store.commit('onActiveName', tab.name)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/KyltMUpdate.vue